import React from "react";
import styles from "./styles.module.scss";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import SessionQuantityInput from "./SessionQuantityInput";

const ManualTrackingSection = ({
  isPackage = false,
}) => {
  const { t } = useTranslation();
  const {  setValue, watch } = useFormContext();
  const unlimited = watch("unlimited");
  const numberOfSessions = watch("number_of_sessions");

  const isUnlimited = !!unlimited || numberOfSessions === -1;
  const displayQty =
    isUnlimited || numberOfSessions == null
      ? 1
      : Math.max(1, Number(numberOfSessions) || 1);

  return (
    <div className={styles.session_settings}>
      <label className={styles.sectionLabelManual}>{t("Number of Sessions")}</label>
      <div className={styles.booking_box_manual}>
        <div className={styles.override_horizontal_layout}>
          <SessionQuantityInput
            quantity={displayQty}
            isUnlimited={!!unlimited}
            onChangeQuantity={(val) => setValue("number_of_sessions", val)}
            onToggleUnlimited={(checked) => {
              setValue("unlimited", checked);
              setValue("number_of_sessions", checked ? null : 1);
            }}
            label={t("Sessions Quantity")}
            isPackage={isPackage}
          />
        </div>
      </div>
    </div>
  );
};

export default ManualTrackingSection;
